import { MemCommonMentionKind } from "@mem-labs/common-editor";
import { MDSComboboxMention } from "./combobox.types";

/**
 * Extracts the unique identifier from a mention object.
 * For collections, returns collection_id; for notes, returns note_id.
 */
export const getMentionId = (mention: MDSComboboxMention): string => {
  return mention.kind === MemCommonMentionKind.Collection ? mention.collection_id : mention.note_id;
};

/**
 * Extracts the display label from a mention object.
 * For collections, returns collection_title; for notes, returns note_primary_label.
 */
export const getMentionLabel = (mention: MDSComboboxMention): string => {
  return mention.kind === MemCommonMentionKind.Collection
    ? mention.collection_title
    : mention.note_primary_label;
};
